import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import QuickCard from '../QuickCard';
import QuickDataModal from '../QuickDataModal';
import { WarningIcon } from '../../../../../../common/icons';

import parseISO from 'date-fns/parseISO';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';

@inject('translationsStore', 'commonStore', 'pagedCollectionStore')
@observer
export default class QuickGroupAlarms extends Component {
  constructor(props) {
    super(props);

    const { translationsStore, commonStore } = this.props;

    this.emptyValue = '-';
    this.itemsPerPage = 7;
    this.namespacePrefix = 'alarms';
    this.historicalFnName = 'historyAlarms';
    this.liveColumns = [
      {
        key: 'description',
        dataIndex: 'description',
        title: translationsStore.translate('quickhealth.alarms.liveColumns.description'),
        sorter: true
      },
      {
        key: 'lastReceivedAt',
        dataIndex: 'lastReceivedAt',
        title: translationsStore.translate('quickhealth.alarms.liveColumns.lastReceivedAt'),
        className: 'CenterNoWrap',
        render: (text, record) => {
          let style = {
            textAlign: 'center',
            whiteSpace: 'nowrap'
          };
          return (
            <div style={style}>
              {text !== this.emptyValue ? formatDistanceToNow(parseISO(record.lastReceivedAt), { addSuffix: true, locale: commonStore.dateFnsLocale }) : this.emptyValue}
            </div>
          );
        },
        sorter: true
      },
      {
        key: 'km',
        dataIndex: 'km',
        title: translationsStore.translate('quickhealth.alarms.liveColumns.km'),
        className: 'CenterNoWrap',
        render: (text, record) => {
          let style = {
            textAlign: 'center',
            whiteSpace: 'nowrap'
          };
          return <div style={style}>{text !== this.emptyValue && record.km ? `${record.km.toLocaleString(commonStore.momentLocale)} km` : this.emptyValue}</div>;
        },
        sorter: true
      }
    ];
    this.quickColumns = this.liveColumns.map(column => ({ ...column, sorter: false }));
    this.historicalColumns = [
      {
        key: 'description',
        dataIndex: 'description',
        title: translationsStore.translate('quickhealth.alarms.historicalColumns.description'),
        sorter: true
      },
      {
        key: 'recordedAt',
        dataIndex: 'recordedAt',
        title: translationsStore.translate('quickhealth.alarms.historicalColumns.recordedAt'),
        className: 'CenterNoWrap',
        render: (text, record) => {
          let style = {
            textAlign: 'center',
            whiteSpace: 'nowrap'
          };
          return <div style={style}>{text !== this.emptyValue ? new Date(record.recordedAt).toLocaleDateString(commonStore.momentLocale) : this.emptyValue}</div>;
        },
        sorter: true
      },
      {
        key: 'initialOdometer',
        dataIndex: 'initialOdometer',
        title: translationsStore.translate('quickhealth.alarms.historicalColumns.initialOdometer'),
        className: 'CenterNoWrap',
        render: (text, record) => {
          let style = {
            textAlign: 'center',
            whiteSpace: 'nowrap'
          };
          return <div style={style}>{text !== this.emptyValue && record.initialOdometer ? `${record.initialOdometer.toLocaleString(commonStore.momentLocale)} km` : this.emptyValue}</div>;
        },
        sorter: true
      },
      {
        key: 'km',
        dataIndex: 'km',
        title: translationsStore.translate('quickhealth.alarms.historicalColumns.km'),
        className: 'CenterNoWrap',
        render: (text, record) => {
          let style = {
            textAlign: 'center',
            whiteSpace: 'nowrap'
          };
          return <div style={style}>{text !== this.emptyValue && record.km ? `${record.km.toLocaleString(commonStore.momentLocale)} km` : this.emptyValue}</div>;
        },
        sorter: true
      },
      {
        key: 'resolvedAt',
        dataIndex: 'resolvedAt',
        title: translationsStore.translate('quickhealth.alarms.historicalColumns.resolvedAt'),
        className: 'CenterNoWrap',
        render: (text, record) => {
          let style = {
            textAlign: 'center',
            whiteSpace: 'nowrap'
          };
          return <div style={style}>{text !== this.emptyValue ? new Date(record.resolvedAt).toLocaleDateString() : this.emptyValue}</div>;
        },
        sorter: true
      }
    ];

    this.defaultBase = {
      keyName: 'alarms',
      color: 'var(--alarm-color)',
      caption: translationsStore.translate('quickhealth.alarms.caption'),
      captionOne: translationsStore.translate('quickhealth.alarms.captionOne'),
      icon: <WarningIcon style={{ width: '18px', height: '18px' }} />,
      ctaLabel: translationsStore.translate('quickhealth.alarms.cta'),
      availableColumns: {
        current: this.liveColumns,
        quick: this.quickColumns,
        historical: this.historicalColumns
      },
      collection: undefined
    };

    this.state = {
      modal: {
        visible: false,
        onOk: this.handleToggleDetailed,
        onCancel: this.handleToggleDetailed
      }
    };
  }

  componentDidMount = () => {
    const { car } = this.props;
    if (!!car) {
      this.initCollections(car);
    }
  };

  componentDidUpdate = prevProps => {
    const { car } = this.props;
    if (!!car) {
      if ((!!prevProps.car && prevProps.car.id !== this.props.car.id) || !prevProps.car) {
        this.initCollections(car);
      }
    }
  };

  initCollections = car => {
    const { pagedCollectionStore } = this.props;
    let liveHelper = car.alarms.slice().sort((a, b) => {
      return b.lastReceivedAt > a.lastReceivedAt ? 1 : -1;
    });
    pagedCollectionStore.init({ key: `${this.namespacePrefix}.current`, source: liveHelper, itemsPerPage: this.itemsPerPage, availableInTabs: true });
    pagedCollectionStore.init({ key: `${this.namespacePrefix}.quick`, source: liveHelper, limit: 2, availableInTabs: false });
    pagedCollectionStore.init({
      key: `${this.namespacePrefix}.historical`,
      source: { api: [this.historicalFnName, car.id] },
      itemsPerPage: this.itemsPerPage,
      availableInTabs: true
    });
  };

  handleToggleDetailed = () => {
    this.setState(previousState => ({ modal: { ...previousState.modal, visible: !previousState.modal.visible } }));
  };

  render() {
    const { modal } = this.state;

    const baseDetailed = { ...Object.assign({}, this.defaultBase), ctaLabel: undefined };
    const baseQuick = Object.assign({}, this.defaultBase, { rowThreshold: 2, collection: 'quick' });

    return (
      <Fragment>
        <QuickCard data={baseQuick} collection="quick" onShowDetailedClick={this.handleToggleDetailed} namespacedCollection={`${this.namespacePrefix}.quick`} />
        <QuickDataModal data={baseDetailed} modal={modal} namespacePrefix={this.namespacePrefix} />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickHealth/QuickGroupAlarms/QuickGroupAlarms.js